import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FiltersState {
    isNew: boolean;
    finished: boolean;
    has_problem: boolean;
}

const initialState: FiltersState = {
    isNew: false,
    finished: false,
    has_problem: false,
};

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<FiltersState>) => {
            return { ...state, ...action.payload };
        },
        clearFilters: (state) => {
            return initialState;
        },
    },
});

export const { setFilters, clearFilters } = filtersSlice.actions;

export const filtersReducer = filtersSlice.reducer;
